var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      ref: "finishedActionPopup",
      attrs: { width: "500", persistent: "" },
      model: {
        value: _vm.active,
        callback: function($$v) {
          _vm.active = $$v
        },
        expression: "active"
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "finished-dialog" },
        [
          _c(
            "v-card-title",
            {
              staticClass: "title text--darken-3",
              attrs: { "primary-title": "" }
            },
            [_vm._v("\n      " + _vm._s(_vm.header) + "\n    ")]
          ),
          _vm._v(" "),
          _c("v-card-text", { staticClass: "subtitle text--darken-1" }, [
            _vm._v("\n      " + _vm._s(_vm.body) + "\n    ")
          ]),
          _vm._v(" "),
          _c("v-card-text", { staticClass: "subtitle text--darken-1" }, [
            _vm._v("\n      " + _vm._s(_vm.preFooter) + "\n    ")
          ]),
          _vm._v(" "),
          _c("v-card-text", { staticClass: "subtitle text--darken-1" }, [
            _vm._v("\n      " + _vm._s(_vm.footer) + "\n    ")
          ]),
          _vm._v(" "),
          _c("v-divider", { staticStyle: { "border-color": "primary" } }),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "dialog-continue-button",
                  attrs: { flat: "" },
                  on: { click: _vm.continueTo }
                },
                [_vm._v("\n        Weiter\n      ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }